export const faqData = () => {
  return [
    {
      title: "How will I access and share my tickets for the 2024 season?",
      htmlDescription:
        'All tickets for the 2024 season are mobile-only and can be accessed and managed via the <a href="https://www.raysbaseball.com/mobile" target="_blank">MLB Ballpark app</a> or through your Rays Ticket Account on a mobile device. For more information about mobile tickets, please visit <a href="https://www.raysbaseball.com/mobile" target="_blank">www.raysbaseball.com/mobile.</a>',
    },
    {
      title: "Will paper tickets be available?",
      htmlDescription:
        "Tropicana Field only accepts mobile tickets through the <a href='https://www.raysbaseball.com/mobile' target='_blank'>MLB Ballpark app</a>. Paper tickets, including print-at-home and PDF versions, are not available or accepted.",
    },
    {
      title:
        "How do I access my 20% discount for concessions and merchandise during the 2024 season?",
      htmlDescription:
        "Access to your Season Member discount is available exclusively via the <a href='https://www.raysbaseball.com/mobile' target='_blank'>MLB Ballpark app</a> on your mobile device.",
    },
  ];
};
